import NextLink from 'next/link';
import PropTypes from 'prop-types';

import PageButton from './Button';

const PageLinkButton = ({
  href = false,
  children,
  isActive,
  onClick,
  ...rest
}) => {
  if (href) {
    return (
      <NextLink href={href} prefetch={false} passHref>
        <PageButton as="a" isActive={isActive} onClick={onClick} {...rest}>
          {children}
        </PageButton>
      </NextLink>
    );
  }

  return (
    <PageButton isActive={isActive} onClick={onClick} {...rest}>
      {children}
    </PageButton>
  );
};

PageLinkButton.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node.isRequired,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default PageLinkButton;
